<div class="review-banner">
  <form [formGroup]="form" class="w-full">
    <!-- Top bar: title + submit button -->
    <div class="flex justify-between w-full mb-4">
      <h4>Issue Loss Run</h4>
      <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'" [text]="'Submit'" [size]="'large'" (click)="submit()">
      </lib-button>
    </div>
    <div class="w-full mb-4 text-left">
      <h5 class="my-4">{{ model().dba }} - {{ model().policyNumber }}</h5>
      <h5>Policy Term: {{ model().policyPeriod }}</h5>
    </div>

    <!-- Body text -->
    <div class="w-full mb-4 text-left">
      This policy has reported claims. Please visit NARS to manually obtain Loss Run document and upload
    </div>

    <!-- Loss run section -->
    <h4 class="mb-2 text-left">Loss Run Document</h4>
    <div class="w-full">
      <lib-form-file-attachment
        formControlName="file"
        [acceptedFormats]="['pdf']"
        [placeholder]="'Drag and drop loss run or click to browse'"
        [label]="' '"
        [multiple]="false"
      ></lib-form-file-attachment>
      <div class="w-full text-left mt-5"></div>
    </div>
    <div class="w-full text-left mt-5">
      <lib-form-text-area formControlName="comments" label="Comments" [rows]="5"></lib-form-text-area>
    </div>
  </form>
</div>
